const FIELD_LABELS: Record<string, string> = {
    vetCnaeOrdem: 'CNAE 7500100 - Ordem',
    cnaePrincipal: 'CNAE Principal',
    dominio: 'Domínio',
    fonteDominio: 'Fonte do domínio',
    midiaSocial: 'Possui mídia social',
    palavras: 'Palavras em Destaque',
    secundarias: 'Atividades Secundárias',
    telefone: 'Telefone',
    estabelecimento: 'Estabelecimento',
    endereco: 'Endereço',
    categorias: 'Categoria',
    municipios: 'Município',
    nota: 'Nota',
    avaliacoes: 'Total de Avaliações',
    aberto24h: 'Aberto 24h',
    instagram: 'Possui Instagram',
    operadoras: 'Nome da Operadora',
    registros: 'Registro ANS',
    ufs: 'UF',
    coberturas: 'Cobertura Assistencial',
    dataCorte: 'Data de Corte',
    atividadeEconomicaCodes: 'Atividade Econômica',
    atividadeEconomicaTexts: 'Atividade Econômica',
    cadeiaValorSaude: 'Cadeia de Valor da Saúde',
    capitalSocial: 'Faixa Capital Social',
    cboCodes: 'CBO - Médicos',
    cboTexts: 'CBO - Médicos',
    cboCategorias: 'CBO - Categoria (Médicos)',
    cnaeClasseCodes: 'CNAE Classe',
    cnaeClasseTexts: 'CNAE Classe',
    cnaeDivisaoCodes: 'CNAE Divisão',
    cnaeDivisaoTexts: 'CNAE Divisão',
    cnaeGrupoCodes: 'CNAE Grupo',
    cnaeGrupoTexts: 'CNAE Grupo',
    cnaeSecaoCodes: 'CNAE Seção',
    cnaeSecaoTexts: 'CNAE Seção',
    cnaeSetorCods: 'CNAE Setor',
    crescimento2021: 'Crescimento 2021',
    crescimento2022: 'Crescimento 2022',
    crescimento2024: 'Crescimento 2024',
    dtCompetenciaInicioAtividade: 'Competência Início Atividade',
    dtSituacaoCadastral: 'Data Situação Cadastral',
    email: 'E-mail',
    empresaCnes: 'CNES',
    empresaCnpjGrupo: 'CNPJ Grupo',
    empresaCnpjMatriz: 'CNPJ Matriz',
    empresaCodigo: 'CNPJ',
    empresaGrupoCodes: 'Grupo Econômico',
    empresaNomeFantasia: 'Nome Fantasia',
    empresaNomeMatriz: 'Nome Matriz',
    empresaRazaoSocial: 'Nome Empresa',
    enchenteRs2024: 'Enchente RS 2024',
    enchenteRs2024_05_02: 'Enchente RS 2024',
    enchenteRs2024_05_06: 'Enchente RS 2024',
    enderecoBairroCodes: 'Bairro',
    enderecoBairroTexts: 'Bairro',
    enderecoCeps: 'CEP',
    enderecoCepTexts: 'CEP',
    enderecoCidadeCodes: 'Município',
    enderecoCidadeTexts: 'Município',
    enderecoCodes: 'Endereço',
    enderecoComplementoTexts: 'Complemento',
    enderecoLatitude: 'Latitude',
    enderecoLongitude: 'Longitude',
    enderecoNumeros: 'Número',
    enderecoRegiaoMetropolitanaCodes: 'Região Metropolitana',
    enderecoRegiaoMetropolitanaTexts: 'Região Metropolitana',
    enderecoRuaCodes: 'Logradouro',
    enderecoRuaTexts: 'Logradouro',
    enderecoTexts: 'Endereço',
    enderecoUfs: 'UF',
    enderecoUfTexts: 'UF',
    faturamentoEstimado: 'Faixa Faturamento Anual',
    faturamentoEstimadoGrupo: 'Faixa Faturamento Grupo',
    idadeEmpresaEmAnos: 'Idade Empresa em Anos',
    inicioAtividade: 'Início Atividade',
    localizacao: 'Área no mapa',
    matrizFilial: 'Matriz/Filial Descrição',
    matrizOrFilial: 'Matriz/Filial',
    matrizUfs: 'UF Matriz',
    mediaCrescimento2021_a_2022: 'Méd.Crescimento 21/22',
    mediaCrescimento2022_a_2024: 'Méd.Crescimento 22/24',
    naturezaJuridicaCodeList: 'Natureza Jurídica',
    naturezaJuridicaCodes: 'Natureza Jurídica',
    naturezaJuridicaGrupoCodes: 'Natureza Jurídica - Grupos',
    naturezaJuridicaPublicaPrivadaCodes: 'Natureza Jurídica - Pública/Privada',
    naturezaJuridicaTexts: 'Natureza Jurídica',
    optanteMei: 'Optante MEI',
    optanteSimples: 'Optante Simples',
    percentualFuncionariasMulheres: '% de Funcionárias Mulheres',
    pesCboCodes: 'CBO - Vínculos',
    pesCboTexts: 'CBO - Vínculos',
    pesCboCategorias: 'CBO - Categoria (Vínculos)',
    pesCodigo: 'Vínculo',
    pesNome: 'Vínculo',
    porteEstabelecimentoSaudeCodes: 'Porte do Estabelecimento de Saúde (Leitos)',
    portePorFaturamentoEstimadoCnpj: 'Porte por Fat. Estimado do CNPJ',
    portePorFaturamentoEstimadoGrupo: 'Porte por Fat. Estimado do Grupo Econômico',
    portePorFuncionarios: 'Porte por Funcionários',
    porteReceitaFederal: 'Porte Receita Federal',
    prfCodigo: 'Médico',
    prfNome: 'Médico',
    regiaoGeograficaImediata: 'Região Geográfica Imediata',
    regiaoGeograficaImediataCodes: 'Região Geográfica Imediata',
    regiaoGeograficaIntermediaria: 'Região Geográfica Intermediária',
    regiaoGeograficaIntermediariaCodes: 'Região Geográfica Intermediária',
    regimeTributario: 'Regime Tributário',
    salarioTotal: 'Salário Total',
    salarioTotalGrupo: 'Salário Total Grupo',
    scoreRiscos: 'Score Risco',
    situacaoCadastral: 'Situação Cadastral',
    socioCodigo: 'Sócio',
    socioKey: 'Sócio',
    socioNome: 'Sócio',
    telefone1: 'Telefone 1 - RF',
    telefone2: 'Telefone 2 - RF',
    tipoAtividadeEconomicaCodes: 'CNAE',
    tipoAtividadeEconomicaTexts: 'CNAE',
    tipoEstabelecimentoSaudeCodes: 'Tipo de Estabelecimento de Saúde',
    totalEmpresasNoGrupo: 'Total Empresas no grupo',
    totalFiliais: 'Total de Filiais',
    totalFuncionarios: 'Faixa Funcionários',
    totalFuncionarios_0_a_18: 'Qtde Func. até 18 anos',
    totalFuncionarios_19_a_33: 'Qtde Func. 19 a 33 anos',
    totalFuncionarios_34_a_48: 'Qtde Func. 34 a 48 anos',
    totalFuncionarios_49_a_58: 'Qtde Func. 49 a 58 anos',
    totalFuncionarios_59_ou_mais: 'Qtde Func. 59+ anos',
    totalFuncionariosDoGrupo: 'Faixa Funcionários Grupo',
    totalFuncionariosFemininos: 'Qtde Func. Femininos',
    totalFuncionariosMasculinos: 'Qtde Func. Masculinos',
    totalFuncionariosMatrizEFiliais: 'Total de Funcionários - Matriz + Filiais',
    webCategoriasTexts: 'Internet - Categorias',
    webNomeTexts: 'Internet - Nome',
    webNota: 'Internet - Nota',
    webQtdAvaliacoes: 'Internet - Total de avaliações',
    webSite: 'Internet - Website',
    webTelefone: 'Internet - Telefone',
    webTempoMedio: 'Internet - Tempo Médio'
}

export function filterFieldLabel(key: string): string {
    return FIELD_LABELS[key] ?? key
}

export function describeFilterFields(fieldKeys?: string[]): string[] {
    if (!fieldKeys || fieldKeys.length === 0) {
        return []
    }

    const labels = new Set<string>()
    fieldKeys.forEach((key) => labels.add(filterFieldLabel(key)))

    return [...labels].sort((a, b) => a.localeCompare(b))
}
